import { useState } from "react";
import Step from "./Step";
import ProcessContent from "./ProcessContent";
import { stepsData } from "./data";

const ERPApproach = () => {
  const [activeTab, setActiveTab] = useState("step-one");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="fiu-process-row">
      <div className="fiu-process-outer erm-approach-outer">
        {/* Left section */}
        <div className="fiu-process-left">
          <ul className="fiu-process-list">
            {stepsData.map((step) => (
              <Step
                key={step.id}
                stepId={step.id}
                title={step.title}
                description={step.description}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
              />
            ))}
          </ul>
        </div>

        {/* Right section */}
        <div className="fiu-process-right process-right-none">
          <div
            className="tools_rt_inner process-right-lists"
            id="tools_rt_scroll"
          >
            {stepsData.map((step) => (
              <ProcessContent
                key={step.id}
                stepId={step.id}
                activeTab={activeTab}
                description={step.content}
                imageSrc={step.imageSrc}
              />
            ))}
          </div>
        </div>

        {/* Mobile Accordion */}
        <div className="fiu-process-right process-right-mobile">
          <div
            className="tools_rt_inner process-right-lists"
            id="tools_rt_scroll"
          >
            {stepsData.map((step) => (
              <div key={step.id} id={step.id}>
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection(step.id)}
                >
                  <div>
                    <span
                      // className="fiu-left-content-title"
                      className={`fiu-left-content-title text-nowrap ${
                        activeSection === step.id ? "active" : ""
                      }`}
                    >
                      {step.title}
                    </span>
                    <span
                      // className="fiu-left-content-title "
                      className={`mx-3 fiu-left-content-title ${
                        activeSection === step.id ? "active" : ""
                      }`}
                    >
                      {step.description}
                    </span>
                  </div>
                </div>

                {activeSection === step.id && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={step.imageSrc}
                          alt="Custom Software Development Company"
                        />
                        <h6>{step.content.title}</h6>
                        <p>{step.content.text}</p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="fiu-need-left-btn mt-3 re-hero-btn"
                        >
                          <div className="re-btn-txt">
                            Get Free Consultation
                          </div>
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ERPApproach;
